var map = {
	"./add.svg": 227,
	"./arrowDown.svg": 117,
	"./arrowUp.svg": 118,
	"./br.svg": 228,
	"./camera.svg": 229,
	"./close.svg": 230,
	"./copy.svg": 231,
	"./delete.svg": 232,
	"./done.svg": 233,
	"./en.svg": 234,
	"./es.svg": 235,
	"./faceFrame.svg": 236,
	"./face_overlay.svg": 237,
	"./qrcodeframe.svg": 238,
	"./restart.svg": 239,
	"./settings-white.svg": 240,
	"./success.svg": 241,
	"./switch_camera.svg": 242,
	"./take_photo.svg": 243,
	"./translate.svg": 119,
	"./us.svg": 244,
	"./values.svg": 245,
	"./white-camera.svg": 246,
	"./white-check.svg": 247,
	"./white-restart.svg": 248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226;